import { useTranslation } from 'react-i18next'

import { Alert, Card, Link, Text, useSetLanguage } from '@reveni-io/reveni-ui'

import { formatOrderDate } from '@/helpers'
import { evaluationOptOutDurationInDays } from '@/helpers/evaluationOptOut/constants'

import useEvaluationOptOut from './hooks/useEvaluationOptOut/useEvaluationOptOut'
import { evaluationOptOutPageLanguages } from './constants'
import { getLegalLinks } from './helpers'
import * as Styles from './styles'

const EvaluationOptOutPage = () => {
  const { t, i18n } = useTranslation()
  const { expirationDate } = useEvaluationOptOut()
  const legalLinks = getLegalLinks(i18n.language)

  useSetLanguage(evaluationOptOutPageLanguages)

  return (
    <Styles.Layout>
      <Styles.Logo src="/logos/reveni_logo.svg" alt="reveni_logo" />
      <Styles.CardContainer>
        <Card title={t('Has desactivado la opción de reembolso instantáneo')}>
          <Styles.Content>
            <Alert type="success">
              <Text tag="span" type="bodyMBold">
                {t('Periodo de exclusión')}
              </Text>
              <br />
              {t('Válida hasta el {{date}}.', { date: formatOrderDate(expirationDate, i18n.language) })}
            </Alert>
            <Text type="bodyMRegular">
              {t(
                'Durante los próximos {{days}} días no te ofreceremos el reembolso instantáneo en ninguna devolución que inicies desde este dispositivo. Tu reembolso se procesará cuando se reciba tu devolución, como en cualquier devolución estándar.',
                { days: evaluationOptOutDurationInDays }
              )}
            </Text>
          </Styles.Content>
        </Card>
      </Styles.CardContainer>
      <Styles.LegalLinks>
        <Link href={legalLinks.termsAndConditions}>{t('Términos y Condiciones')}</Link>
        <Link href={legalLinks.privacyPolicy}>{t('Política de privacidad')}</Link>
      </Styles.LegalLinks>
    </Styles.Layout>
  )
}

export default EvaluationOptOutPage
